<template>
  <CalculationElementLayout :node-id="nodeId">
    <v-row>
      <v-col cols="6">
        <v-container class="bordered bg-white mb-4">
          <CalcInputSelect
            :id="nodeId"
            class="mb-4"
            field="activity_labour"
            :items="activities"
            :rules="[required]" />

          <CalcInputNumber
            :id="nodeId"
            class="mb-4"
            field="labour_retention_percentage_labour"
            :rules="[required, percents]" />
        </v-container>
      </v-col>
    </v-row>
  </CalculationElementLayout>
</template>

<script setup>
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";

import { useCommonRules } from "@/validations/common";

import { useSpaceStore } from "../../stores/spaceStore";
import CalculationElementLayout from "@/layouts/CalculationElementLayout.vue";
import { useTreeStore } from "@/stores/treeStore";
import CalcInputSelect from "@/components/Elements/CalcInputSelect.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const treeStore = useTreeStore();
const { required, percents } = useCommonRules(t);
const route = useRoute();

const nodeId = computed(() => route.params.nodeId);

const activities = computed(() => {
  return Object.entries(spaceStore.calculationElements)
    .reduce((result, [id, element]) => {
      if (id.endsWith("activity")) {
        result.push(Object.assign({}, element, { id }));
      }
      return result;
    }, [])
    .filter(
      (activity) =>
        activity.location === treeStore.elementLocation[nodeId.value]
    )
    .map((activity) => {
      return {
        value: activity.id,
        title: activity.name
      };
    });
});
</script>
